import React from "react";
import ToggleMulti from "components/ToggleMulti";
import PercentageIcon from "assets/images/icons/JSX/EmbCPercentage";
import GradeIcon from "assets/images/icons/JSX/EmbCGrade";

const PercentGradeSwitch = ({ activeTab, setActiveTab }) => {
    const fillColor = (id) => {
        if (activeTab === id) {
            return "#0049C6";
        } else {
            return "#646F81";
        }
    };

    return (
        <ToggleMulti
            options={[
                {
                    id: "grade",
                    icon: () => <GradeIcon fill={fillColor("grade")} />,
                    onClick: () => setActiveTab("grade"),
                    tip: "Embodied carbon scale relative to other materials in the same category",
                },
                {
                    id: "percentage",
                    icon: () => <PercentageIcon fill={fillColor("percentage")} />,
                    onClick: () => setActiveTab("percentage"),
                    tip: "Embodied carbon scale based on each layer's percent contribution",
                },
            ]}
            active={activeTab}
        />
    );
};

export default PercentGradeSwitch;
